export const LIMITS = {
    titleMinLength: 3,
    titleMaxLength: 50,
    emailMaxLength: 100,
    passwordMinLength: 8,
    passwordMaxLength: 20,
    phoneMinLength: 10,
    phoneMaxLength: 10,
    descriptionMinLength: 3,
    descriptionMaxLength: 1000,
}
